module.exports = __webpack_public_path__ + "static/img/logo.3bd72111.png";